import {CommonConstant} from '../../app/app.constants';
import {DateRange} from '../date-range';

export class MeasureSearchCriteria {
  project_id: number;
  campaign_id: number;
  mention: number;
  blog_id: number;
  channel: number;
  influencerGroup: number;
  date = CommonConstant.DAYS_OF_WEEK;
  page_no: number;
  company_id: number;
  country_id: number;
  period: DateRange;
  orderBy: string;
}



// WEBPACK FOOTER //
// ./src/models/measure/measure-search-criteria.ts